import sections from './kine-consultation-sections.json'
export const kineSection = slug => sections.find(s => !s.native && s.slug === slug)
export { clinicNow } from './kine-clinical-time'
export function difference(column, row) {
    const values = column.subtract.map(key => row[key])
    if (values.some(v => v === '' || v === null || v === undefined || !Number.isFinite(Number(v)))) return ''
    return Number((Number(values[0]) - Number(values[1])).toFixed(8))
}
export function initializeKineFields(slug, fields, saved = [], now = '') {
    const spec = kineSection(slug)
    if (!spec) return fields
    return fields.map(field => {
        const definition = spec.fields.find(d => d.label === field.field_name)
        if (!definition) return field
        const found = saved.find(item => item.field_name === field.field_name)
        const previous = found ? JSON.parse(JSON.stringify(found)) : null
        if (previous) return { ...previous, ...(definition.kind === 'practitioner' ? { value: previous.practitioner_id || previous.value } : {}), ...(definition.kind === 'checkbox' ? { value: previous.checked === true || previous.value === true } : {}), ...(definition.kind === 'grid' ? { rows: previous.rows || [] } : {}) }
        const value = definition.kind === 'multi' ? [] : definition.kind === 'checkbox' ? definition.default === true
            : definition.key === 'session_date' ? now : ''
        return { ...field, value, ...(definition.kind === 'grid' ? { rows: [] } : {}) }
    })
}
